export function hexToRgb(hex) {
  const cleanHex = hex.replace("#", "");
  const bigint = parseInt(cleanHex, 16);
  return {
    r: (bigint >> 16) & 255,
    g: (bigint >> 8) & 255,
    b: bigint & 255,
  };
}

export function rgbToHex(r, g, b) {
  return (
    "#" +
    [r, g, b]
      .map((x) => {
        const hex = x.toString(16);
        return hex.length === 1 ? "0" + hex : hex;
      })
      .join("")
  );
}

// Adjusts an RGB color to preserve the relative lightness ratios of the original theme presets and returns the hex code
// This is used to generate consistent derived colors
// when a user changes the base/primary color. The ratios between color channels are preserved
export function adjustColorByDifference(baseColor, largest, medium, smallest) {
  const rbg = hexToRgb(baseColor);
  // make an array of objects ordered by smallest to largest
  const inputs = Object.entries(rbg).sort((a, b) => a[1] - b[1]);
  // console.log(inputs);

  // set the values of rgb to match the ratio of the original presets
  inputs[0][1] = 255 * largest;
  inputs[1][1] = 255 * medium;
  inputs[2][1] = 255 * smallest;

  const { r, g, b } = Object.fromEntries(inputs);
  return rgbToHex(r, g, b);
}

// export function adjustColor(hex, percent) {
//   const { r, g, b } = hexToRgb(hex);
//   const adjust = (channel) =>
//     Math.min(255, Math.max(0, Math.round(channel + (percent / 100) * 255)));

//   return rgbToHex(adjust(r), adjust(g), adjust(b));
// }

// add the r,g,b components onto the baseColor
// export function adjustColorRgb(baseColor, redAmount, greenAmount, blueAmount) {
//   const { r, g, b } = hexToRgb(baseColor);
//   // The min, max is 0, 255
//   // if the added value is positive, take the max, if the added value is negative, take the min
//   const adjust = (color, amount) => {
//     if (amount > 0) {
//       return Math.min(255, Math.max(0, Math.round(color + amount)));
//     } else {
//       return Math.max(0, Math.round(color + amount)); //amount will be negative
//     }
//   };

//   return rgbToHex(
//     adjust(r, redAmount),
//     adjust(g, greenAmount),
//     adjust(b, blueAmount)
//   );
// }

// export function adjustColorByRatio(baseColor, redRatio, greenRatio, blueRatio) {
//   const { r, g, b } = hexToRgb(baseColor);

//   const adjust = (channel, ratio) =>
//     Math.min(255, Math.max(0, Math.round(channel + ratio * (channel || 1)))); // avoid multiplying by 0

//   return rgbToHex(
//     adjust(r, redRatio),
//     adjust(g, greenRatio),
//     adjust(b, blueRatio)
//   );
// }
